export const dafultSchema = {
	json_base: {
		$schema: "http://json-schema.org/draft-07/schema#",
		additionalProperties: false,
		description: "validation scheme for resource",
		properties: {
			additional_info: {
				additionalProperties: false,
				properties: {},
				required: [],
				type: "object",
			},
			email: {
				pattern: "^[_a-z0-9-]+(\\.[_a-z0-9-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,4})$",
				type: "string",
			},
			identification: {
				minLength: 5,
				type: "string",
			},
			lastname: {
				minLength: 3,
				type: "string",
			},
			name: {
				minLength: 3,
				type: "string",
			},
			username: {
				minLength: 5,
				type: "string",
			},
		},
		required: ["name", "lastname", "username", "email", "identification", "additional_info"],
		title: "schema resource",
		type: "object",
	},
	json_properties: [
		{
			label: "enter name",
			name: "name",
			type: "text",
		},
		{
			label: "enter lastname",
			name: "lastname",
			type: "text",
		},
		{
			label: "enter username",
			name: "username",
			type: "text",
		},
		{
			label: "enter email",
			name: "email",
			type: "email",
		},
		{
			label: "enter identification",
			name: "identification",
			type: "text",
		},
		{
			label: "",
			name: "additional_info",
			type: {},
		},
	],
};
